// extracted by mini-css-extract-plugin
export default {"pageWrapper":"page-wrapper_pageWrapper__fGMxQ"};